import { Plan } from '@/src/components/desktop/srp/fareFamily/types'
import FareRulesDrawer from '@/src/components/mobile/itinerary/transperencyWidget/fareRulesdrawer/fareRulesdrawer'
import { TranslationFunction } from '@/src/types/translations'
import { Box } from '@mui/material'
import SwipeableDrawerWithBackNavigation from '@/src/components/common/ui/swipeableDrawer'

interface SRPFareRulesDrawerWrapperProps {
    open: boolean
    onClose: () => void
    plan: Plan | null
    t: TranslationFunction<'common'>
}

const SRPFareRulesDrawerWrapper = ({ open, onClose, plan, t }: SRPFareRulesDrawerWrapperProps) => {
    if (!plan || !plan.toolTipData) {
        return null
    }

    const {
        processedFareRules = [],
        baggageData = [],
        rawBaggage = [],
        fareTitle = plan.title,
        price = plan.displayPrice
    } = plan.toolTipData

    return (
        <SwipeableDrawerWithBackNavigation
            anchor="bottom"
            open={open}
            onClose={onClose}
            onOpen={() => {}} // Required prop for SwipeableDrawer
            disableSwipeToOpen={false}
            sx={{
                zIndex: 1400,
                overflow: 'hidden'
            }}
        >
            <Box
                sx={{
                    flex: 1,
                    overflow: 'auto',
                    overflowX: 'hidden',
                    WebkitOverflowScrolling: 'touch',
                    scrollBehavior: 'smooth',
                    overscrollBehavior: 'contain'
                }}
            >
                <FareRulesDrawer
                    processedFareRules={processedFareRules}
                    baggageData={baggageData}
                    rawBaggage={rawBaggage}
                    price={price}
                    fareTitle={fareTitle}
                    isParentOpen={open}
                    onClose={onClose}
                    t={t}
                    isPerPaxPriceEnabled={plan.isPerPaxPricingDefined}
                />
            </Box>
        </SwipeableDrawerWithBackNavigation>
    )
}

export default SRPFareRulesDrawerWrapper
